import { render, staticRenderFns } from "./GirdTable.vue?vue&type=template&id=04a210e0"
import script from "./GirdTable.vue?vue&type=script&lang=js"
export * from "./GirdTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports